import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VcmMainComponent } from './vcm-main/vcm-main.component';
import { VcmComponent } from './vcm/vcm.component';

const routes: Routes = [
  {
    path: '',
    component: VcmMainComponent,
    children: [
      {
        path: '',
        component: VcmComponent
      }
    ]
  },
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  declarations: [],
})
export class VcmRoutingModule { }
